import React from "react";
import { Link } from 'react-router-dom';   

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight} from '@fortawesome/free-solid-svg-icons'

function Blogs() {
  return (
    <main>
         <div className="chitto">
        <div className="banner-contact">
          <img src="/img/Heli1.webp" alt="help" />
          <div className="banner-contact-box"></div>
          <div className="contactus-header">
        <h1>Why Choose Us</h1>
        <p>Innovating Travel Industry and helping Travellers is our main goal</p>
      </div>
      </div>
      </div>
    <div className="whychooseus-section">

      <div className="whychooseus-container">

      <Link href="/blog-1" className="blog-card">
          <div className="blog-image">
            <img
              src="/img/pokhara4.jpg"
              alt="Best Time to Visit Nepal"
            />
          </div>
          <div className="blog-content">
            <span className="blog-date">Jan 10, 2026</span>
            <h3>Best Time to Visit Nepal</h3>
            <button className='red-but'>Read Now <FontAwesomeIcon icon={faArrowAltCircleRight}></FontAwesomeIcon> </button>
          </div>
        </Link>

        <Link href="/blog-1" className="blog-card">
          <div className="blog-image">
            <img
              src="/img/pokhara4.jpg"
              alt="Best Time to Visit Nepal"
            />
          </div>
          <div className="blog-content">
            <span className="blog-date">Jan 10, 2026</span>
            <h3>Best Time to Visit Nepal</h3>
            <button className='red-but'>Read Now <FontAwesomeIcon icon={faArrowAltCircleRight}></FontAwesomeIcon> </button>
          </div>
        </Link>

        <Link href="/blog-1" className="blog-card">
          <div className="blog-image">
            <img
              src="/img/pokhara4.jpg"
              alt="Best Time to Visit Nepal"
            />
          </div>
          <div className="blog-content">
            <span className="blog-date">Jan 10, 2026</span>
            <h3>Best Time to Visit Nepal</h3>
            <button className='red-but'>Read Now <FontAwesomeIcon icon={faArrowAltCircleRight}></FontAwesomeIcon> </button>
          </div>
        </Link>

        <Link href="/blog-1" className="blog-card">
          <div className="blog-image">
            <img
              src="/img/pokhara4.jpg"
              alt="Best Time to Visit Nepal"
            />
          </div>
          <div className="blog-content">
            <span className="blog-date">Jan 10, 2026</span>
            <h3>Best Time to Visit Nepal</h3>
            <button className='red-but'>Read Now <FontAwesomeIcon icon={faArrowAltCircleRight}></FontAwesomeIcon> </button>
          </div>
        </Link>

      </div>
    </div>
    </main>
  );
}

export default Blogs;